import { generateTheme } from '@staizen/graphene';
import { Theme, lightTheme, darkTheme } from './constants';

export default function configureTheme(): void {
  generateTheme(Theme.Dark, darkTheme);
  generateTheme(Theme.Light, lightTheme);
}
